import React, { useEffect, useRef } from 'react';
import { Prompt } from 'react-router-dom';

const UnloadPrompt = (props) => {
  const { when = true, message } = props;
  const cb = useRef((e) => {
    if (when) {
      e.preventDefault();
      e.returnValue = message;
    }
  });

  useEffect(() => {
    window.addEventListener('beforeunload', cb.current);

    return () => window.removeEventListener('beforeunload', cb.current);
  }, []);

  return <Prompt {...props} />;
};

export default UnloadPrompt;
